import { render, staticRenderFns } from "./CardPrensa.vue?vue&type=template&id=4a25caa0&scoped=true"
import script from "./CardPrensa.vue?vue&type=script&lang=js"
export * from "./CardPrensa.vue?vue&type=script&lang=js"
import style0 from "./CardPrensa.vue?vue&type=style&index=0&id=4a25caa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a25caa0",
  null
  
)

export default component.exports